// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nav-wrapper .v-toolbar__title {\n  overflow: visible;\n}\n.nav-wrapper .logo {\n  max-width: 100px;\n  justify-self: center;\n}\n.nav-wrapper .title-custom {\n  margin-left: 15px;\n  padding-left: 10px;\n  font-size: 16px !important;\n  border-left: 2px solid #fff;\n  text-transform: uppercase;\n  font-weight: 600;\n  padding: 6px 10px;\n}", ""]);
// Exports
module.exports = exports;
